module.exports = __webpack_public_path__ + "img/scanCreationWhite.de481167.svg";